/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToApiResponse, convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminAttentionResp,
    AdminAttentionRespFromJSON,
    AdminAttentionRespToJSON,
    AdminProductAnalyticsResp,
    AdminProductAnalyticsRespFromJSON,
    AdminProductAnalyticsRespToJSON,
    AdminResolveAttentionReq,
    AdminResolveAttentionReqFromJSON,
    AdminResolveAttentionReqToJSON,
    AdminResolveAttentionResp,
    AdminResolveAttentionRespFromJSON,
    AdminResolveAttentionRespToJSON,
    AdminRunAnalyticsReq,
    AdminRunAnalyticsReqFromJSON,
    AdminRunAnalyticsReqToJSON,
    AdminRunAnalyticsResp,
    AdminRunAnalyticsRespFromJSON,
    AdminRunAnalyticsRespToJSON,
} from '../models';

export interface AdminAnalyticsApiAdminDashboardAttentionRequest {
    marketplace?: AdminDashboardAttentionMarketplaceEnum;
    limit?: number;
    sort?: AdminDashboardAttentionSortEnum;
}

export interface AdminAnalyticsApiAdminProductAnalyticsRequest {
    id: string;
}

export interface AdminAnalyticsApiAdminResolveAttentionRequest {
    id: string;
    params: AdminResolveAttentionReq;
}

export interface AdminAnalyticsApiAdminRunAnalyticsRequest {
    params: AdminRunAnalyticsReq;
}

export interface AdminAnalyticsApiAdminUnresolveAttentionRequest {
    productId: string;
}

export function createAdminDashboardAttentionPath(): string {
    return `/admin/dashboard/attention`;
}
export function createAdminDashboardAttentionFullPath(): string {
    return runtime.BASE_PATH + `/admin/dashboard/attention`;
}
export function createAdminProductAnalyticsPath(id: string): string {
    return `/admin/products/{id}/analytics`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminProductAnalyticsFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/products/{id}/analytics`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminResolveAttentionPath(id: string): string {
    return `/admin/products/{id}/attention/resolve`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminResolveAttentionFullPath(id: string): string {
    return runtime.BASE_PATH + `/admin/products/{id}/attention/resolve`.replace(`{${'id'}}`, encodeURIComponent(id));
}
export function createAdminRunAnalyticsPath(): string {
    return `/admin/analytics/run`;
}
export function createAdminRunAnalyticsFullPath(): string {
    return runtime.BASE_PATH + `/admin/analytics/run`;
}
export function createAdminUnresolveAttentionPath(productId: string): string {
    return `/admin/products/{product_id}/attention/resolve`.replace(`{${'product_id'}}`, encodeURIComponent(productId));
}
export function createAdminUnresolveAttentionFullPath(productId: string): string {
    return (
        runtime.BASE_PATH +
        `/admin/products/{product_id}/attention/resolve`.replace(`{${'product_id'}}`, encodeURIComponent(productId))
    );
}

/**
 *
 */
export class AdminAnalyticsApi extends runtime.BaseAPI {
    /**
     * Products in sale whose listings need attention (price above the market, not competitive, market below our floor, stale), most important first. Resolved products are hidden.
     * Products needing attention
     */
    async adminDashboardAttention(
        requestParameters?: AdminAnalyticsApiAdminDashboardAttentionRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminAttentionResp>> {
        const queryParameters: any = {};

        if (requestParameters?.marketplace !== undefined) {
            queryParameters['marketplace'] = requestParameters.marketplace;
        }

        if (requestParameters?.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters?.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminDashboardAttentionPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminAttentionRespFromJSON(jsonValue))
        );
    }
    /**
     * Analytics of every listing of the product, the newest eBay market with comparables, and the market and price history.
     * Product price analytics
     */
    async adminProductAnalytics(
        requestParameters: AdminAnalyticsApiAdminProductAnalyticsRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminProductAnalyticsResp>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminProductAnalytics.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminProductAnalyticsPath(String(requestParameters?.id)),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminProductAnalyticsRespFromJSON(jsonValue))
        );
    }
    /**
     * Hides the product from the attention list for the given days, for all admins. It comes back earlier if its worst severity gets worse.
     * Resolve a product on the dashboard
     */
    async adminResolveAttention(
        requestParameters: AdminAnalyticsApiAdminResolveAttentionRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminResolveAttentionResp>> {
        if (requestParameters?.id === null || requestParameters?.id === undefined) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter requestParameters.id was null or undefined when calling adminResolveAttention.'
            );
        }

        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminResolveAttention.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminResolveAttentionPath(String(requestParameters?.id)),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminResolveAttentionReqToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminResolveAttentionRespFromJSON(jsonValue))
        );
    }
    /**
     * Queues, for the given products in sale, a check of their own eBay listings and a fresh eBay market search, then a recompute of their analytics. The worker process runs the jobs; products not in sale are skipped.
     * Run price analytics for products
     */
    async adminRunAnalytics(
        requestParameters: AdminAnalyticsApiAdminRunAnalyticsRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminRunAnalyticsResp>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminRunAnalytics.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminRunAnalyticsPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminRunAnalyticsReqToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminRunAnalyticsRespFromJSON(jsonValue))
        );
    }
    /**
     * Brings the product back to the attention list.
     * Undo Resolve of a product
     */
    async adminUnresolveAttention(
        requestParameters: AdminAnalyticsApiAdminUnresolveAttentionRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<void>> {
        if (requestParameters?.productId === null || requestParameters?.productId === undefined) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter requestParameters.productId was null or undefined when calling adminUnresolveAttention.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminUnresolveAttentionPath(String(requestParameters?.productId)),
                    method: 'DELETE',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
}

/**
 * @export
 */
export const AdminDashboardAttentionMarketplaceEnum = {
    facebook: 'facebook',
    ebay: 'ebay',
    offer_up: 'offer_up',
    craigs_list: 'craigs_list',
    mercari: 'mercari',
    poshmark: 'poshmark',
    walmart: 'walmart',
    depop: 'depop',
} as const;
export type AdminDashboardAttentionMarketplaceEnum =
    (typeof AdminDashboardAttentionMarketplaceEnum)[keyof typeof AdminDashboardAttentionMarketplaceEnum];
/**
 * @export
 */
export const AdminDashboardAttentionSortEnum = {
    priority: 'priority',
    recent: 'recent',
} as const;
export type AdminDashboardAttentionSortEnum =
    (typeof AdminDashboardAttentionSortEnum)[keyof typeof AdminDashboardAttentionSortEnum];
